import { useState, useEffect } from 'react';
import { Request, RequestFilters } from '@/types/requests';

// Dummy data for requests
const DUMMY_REQUESTS: Request[] = [
  {
    _id: 'req_1',
    deviceId: 'device_1',
    deviceName: 'MacBook Pro - Marketing',
    userId: 'user_1',
    userName: 'John Smith',
    url: 'https://youtube.com/watch?v=example',
    domain: 'youtube.com',
    category: 'Entertainment',
    action: 'blocked',
    reason: 'Category blocked by policy',
    status: 'pending',
    timestamp: Date.now() - 3600000, // 1 hour ago
    userAgent: 'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7)',
    ipAddress: '192.168.1.100',
    requestType: 'access',
  },
  {
    _id: 'req_2',
    deviceId: 'device_2',
    deviceName: 'iPad - Research Dept',
    userId: 'user_2',
    userName: 'Sarah Johnson',
    url: 'https://stackoverflow.com/questions/example',
    domain: 'stackoverflow.com',
    category: 'Programming',
    action: 'blocked',
    reason: 'Not in approved category list',
    status: 'approved',
    timestamp: Date.now() - 7200000, // 2 hours ago
    requestType: 'category_change',
    adminNotes: 'Approved for research purposes',
    resolvedBy: 'Admin User',
    resolvedAt: Date.now() - 3600000,
  },
  {
    _id: 'req_3',
    deviceId: 'device_3',
    deviceName: 'iPhone - Sales Team',
    userId: 'user_3',
    userName: 'Mike Wilson',
    url: 'https://linkedin.com/in/client-profile',
    domain: 'linkedin.com',
    category: 'Social Media',
    action: 'blocked',
    reason: 'Social media blocked during work hours',
    status: 'rejected',
    timestamp: Date.now() - 10800000, // 3 hours ago
    requestType: 'whitelist',
    adminNotes: 'Business use case not justified',
    resolvedBy: 'Admin User',
    resolvedAt: Date.now() - 7200000,
  }
];

export const useRequests = (filters?: Partial<RequestFilters>) => {
  const [requests, setRequests] = useState<Request[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Simulate API call delay and filtering
    setTimeout(() => {
      let filteredRequests = DUMMY_REQUESTS;
      
      if (filters?.status && filters.status.length > 0) {
        filteredRequests = filteredRequests.filter(req => 
          filters.status.includes(req.status)
        );
      }
      
      if (filters?.requestType && filters.requestType.length > 0) {
        filteredRequests = filteredRequests.filter(req => 
          filters.requestType.includes(req.requestType)
        );
      }
      
      if (filters?.searchTerm) {
        const term = filters.searchTerm.toLowerCase();
        filteredRequests = filteredRequests.filter(req => 
          req.url.toLowerCase().includes(term) ||
          req.userName.toLowerCase().includes(term) ||
          req.domain.toLowerCase().includes(term)
        );
      }
      
      setRequests(filteredRequests);
      setIsLoading(false);
    }, 500);
  }, [filters]);

  return {
    requests,
    isLoading,
    refetch: () => {
      setIsLoading(true);
      setTimeout(() => {
        setRequests(DUMMY_REQUESTS);
        setIsLoading(false);
      }, 500);
    }
  };
};